import * as React from 'react'
import classnames from 'classnames'
import styles from './index.module.scss'

interface Props {
  /**
   * primary: 黄色底部，常用语询底价
   * default: 带边框
   * highlight: 带边框，颜色为橘色
   */
  type?: 'primary' | 'default' | 'highlight' | 'new_primary'
  style?: React.CSSProperties
  loading?: boolean
  disabled?: boolean
  className?: string
  onClick?: React.MouseEventHandler
}

export default class Button extends React.PureComponent<Props> {
  static defaultProps = {
    type: 'default',
    loading: false,
    disabled: false,
  }

  onClick = (event: React.MouseEvent) => {
    // event.preventDefault()
    // event.stopPropagation()
    const { loading, disabled, onClick } = this.props
    if (loading || disabled) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    if (typeof onClick === 'function') {
      onClick(event)
    }
  }

  render() {
    const { type, style, loading, disabled, children, className } = this.props
    return (
      <span
        onClick={this.onClick}
        className={classnames(className, 'button', [type], {
          [styles.root]: true,
          [styles[type as string]]: true,
          [styles.disabled]: disabled,
          [styles.loading]: loading,
        })}
        role="button"
        style={style}
      >
        {loading ? <i className={styles.loading} /> : children}
      </span>
    )
  }
}
